import React from 'react';
import { useFormContext } from 'react-hook-form';
import type { RegisterOptions } from 'react-hook-form';

import { Field, FieldError, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';

type TicketTextFieldProps = {
  title: string;
  fieldName: string;
  rules?: RegisterOptions;
  placeholder?: string;
  disabled?: boolean;
};

export const TicketTextField: React.FC<TicketTextFieldProps> = ({
  title,
  fieldName,
  rules,
  placeholder,
  disabled,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[fieldName]?.message as string | undefined;
  const required =
    typeof rules?.required === 'object' &&
    rules.required !== null &&
    'value' in rules.required &&
    Boolean((rules.required as { value?: unknown }).value);

  return (
    <Field data-invalid={error ? true : undefined}>
      <FieldLabel htmlFor={fieldName}>
        {title}
        {required ? <span aria-label="Required field"> *</span> : null}
      </FieldLabel>
      <Input
        id={fieldName}
        placeholder={placeholder}
        disabled={disabled}
        aria-invalid={error ? true : undefined}
        {...register(fieldName, rules)}
      />
      <FieldError>{error}</FieldError>
    </Field>
  );
};
